import CartSteps from 'app/components/CartSteps';
import ParticipantsInformation from 'app/components/ParticipantsInformation/ParticipantsInformation';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export interface CartStepsProps {
  displayAddonsStep: boolean;
  isLoading: boolean;
}

const RegistrationFormsPage: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const [cartStepsProps, setCartStepsProps] = useState<CartStepsProps>({
    displayAddonsStep: false,
    isLoading: true,
  });

  const handleCartStepsProps = (data: CartStepsProps) => {
    setCartStepsProps({
      ...data,
    });
  };

  return (
    <div className="page-container">
      <Helmet>
        <title>{t('registrationFormsPage.sectionTitle')}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="section-container">
        <CartSteps
          eventHasRegistrationForms
          displayAddonsStep={
            state?.hasAddonsOrTopUps || cartStepsProps.displayAddonsStep
          }
          isLoading={
            state?.hasAddonsOrTopUps ? false : cartStepsProps.isLoading
          }
        />
        <div className="cart-step-card">
          <div
            className="p-[16px] sm:p-[24px] pb-[0px]! rounded-lg"
            style={{ background: 'var(--cardContentBackground)' }}
          >
            <ParticipantsInformation
              handleCartStepsProps={handleCartStepsProps}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationFormsPage;
